class ABTest {

  /**
   * Initialize ab test.
   *
   * @param {Object} options Test options.
   */
  constructor(options = {}) {
    const defaults = {
      sessionStorageKey: '',
      eventTestCategory: 'ABTest',
      eventTestAction: '',
      type: 'toggleSelector',
      options: [],
      userValue: null
    };

    options = Object.assign(defaults, options);
    for (let option in options) {
      this[option] = options[option];
    }

    // Set user value
    if (!this.userValue) {
      let abValue = window.sessionStorage.getItem(this.sessionStorageKey);
      if (!abValue) {
        const option = this.getRandomOption();
        if (option) {
          abValue = option.key;
          window.sessionStorage.setItem(this.sessionStorageKey, option.key);
        }
      }

      this.userValue = abValue;
    }
  }

  _triggerEvent(option) {
    const isAdmin = window.location.host.indexOf('stage.crasman.fi') > -1;
    if(!isAdmin){
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'dlToAnalytics',
        'eventCategory': this.eventTestCategory,
        'eventAction': this.eventTestAction,
        'eventLabel': option.key
      });
    }
  }

  /**
   * Get random option which is used as user value for this test.
   *
   * @returns {Object|null}
   */
  getRandomOption() {
    const value = Math.random();
    let total = 0;
    for (let i = 0; i < this.options.length; i++) {
      const option = this.options[i];
      total += option.value;
      if (total >= value) {
        return option;
      }
    }

    return null;
  }

  /**
   * Get option by user value.
   *
   * @param {String} key Test key.
   * @returns {Object|null}
   */
  getOption(key) {
    for (let i = 0; i < this.options.length; i++) {
      const option = this.options[i];
      if (option.key === key) {
        return option;
      }
    }

    return null;
  }

  /**
   * Get current user option.
   *
   * @returns {Object|null}
   */
  getUserOption() {
    return this.getOption(this.userValue);
  }

  /**
   * Run test logic.
   *
   * @param {Object} option Selected option.
   */
  runTest(option) {
    if (this.type === 'toggleSelector') {
      const items = document.querySelectorAll(option.selector);
      for (let u = 0; u < items.length; u++) {
        items[u].style.display = 'block';
      }
    }

    this._triggerEvent(option);
  }
}

function initializeABTests() {
  if (window.nhtABTests) {
    window.nhtABTests.forEach(options => {
      const test = new ABTest(options);
      const option = test.getUserOption();
      if (option) {
        test.runTest(option);
      }
    });
  }
}

export default ABTest;

export { initializeABTests };
